// 需要使用低版本crypto-js并按需引入，否则子依赖包含node兼容代码，会很大
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import ECB from "crypto-js/mode-ecb";
import Pkcs7 from "crypto-js/pad-pkcs7";

function decrypt(words, key) {
    var utf8key = Utf8.parse(key);
    var decrypted = AES.decrypt(words, utf8key, {
        mode: ECB,
        padding: Pkcs7,
    });
    return Utf8.stringify(decrypted).toString();
}

// 图片解密
function decryptImg(imgDom) {
    var imgSrc = imgDom.getAttribute("data-src");
    var decryptImgSrc = imgSrc;
    if (!!imgSrc) {
        // 兼容部分文章页的图片没加密的情况
        const notRequiredDecrypt =
            /^https?:\/\//.test(imgSrc) || /^\/\/\w+\.itc\.cn/.test(imgSrc);
        if (!notRequiredDecrypt) {
            try {
                decryptImgSrc = decrypt(imgSrc, "www.sohu.com6666");
            } catch (e) {
                console.log("decrypt err:", e);
                decryptImgSrc = imgSrc;
            }
        }
        imgDom.removeAttribute("data-src");
        imgDom.setAttribute("src", decryptImgSrc);
    }
}

// 兼容性好的懒加载方案
function lazyLoad(imgsList) {
    if ("IntersectionObserver" in window) {
        lazyLoadByObserver(imgsList);
    } else {
        getArticleImg(imgsList);
    }
}

function lazyLoadByObserver(lazyImages) {
    let lazyImageObserver = new IntersectionObserver(function (
        entries,
        observer
    ) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                let lazyImage = entry.target;
                decryptImg(lazyImage);
                lazyImageObserver.unobserve(lazyImage);
            }
        });
    });
    lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
    });
}

function lazyLoadByDefault(imgs) {
    return function () {
        var screenH =
            window.innerHeight || document.documentElement.clientHeight;
        for (var i = 0; i < imgs.length; i++) {
            const bounding = imgs[i].getBoundingClientRect();
            const top = bounding.top;
            const bottom = bounding.bottom;
            const isInView =
                (top <= screenH) & (bottom > 0) ||
                (bottom >= 0 && top <= screenH);
            if (isInView) {
                decryptImg(imgs[i]);
            }
        }
    };
}


const scrollFunc = function (imgs) {
    return throttle(lazyLoadByDefault(imgs), 500);
}

function throttle(func, delay) {
    let canRun = true;
    return function () {
        if (!canRun) return;
        canRun = false;
        const context = this;
        const args = arguments;
        func.apply(context, args);
        setTimeout(() => {
            canRun = true;
        }, delay);
    };
}

function getArticleImg(imgs) {
    let throttledAbc;
    window.addEventListener(
        "scroll",
        function () {
            if (!throttledAbc) {
                throttledAbc = scrollFunc(imgs);
            }
            throttledAbc();
        },
        false
    );
}

const initImgLazyload = () => {
    const imgList = document.querySelectorAll(
        ".article-main .display-content img[data-src]"
    );
    lazyLoad(imgList);
}

const initLastImgLazyload = (selectors) => {
    const defaultSelectors = ".article-main .hidden-content img[data-src]"
    const imgList = document.querySelectorAll(
        selectors || defaultSelectors
    );
    lazyLoad(imgList);
}

export { initImgLazyload, initLastImgLazyload, decrypt };
